import React from "react";
import {
  ShimmerButton,
  ShimmerThumbnail,
  ShimmerText,
  ShimmerTable
} from "react-shimmer-effects";

const CustomiseNudgeLoading2 = () => {
  return (
    <div className="flex flex-col text-white" style={{width:"80%",backgroundColor:"#E5E5E5"}}>
      <div className="p-1 mt-3 ms-4 me-3">
        <ShimmerButton width="100%" height={40}/>
        <ShimmerTable height={50} row={2} col={4} />
      </div>

      <div className="flex flex-col p-5">
        <div className="flex justify-between items-center w-full mb-4">
          <ShimmerText line={1} gap={8} />
          <ShimmerButton width={50} height={30} />
        </div>
        <div className="grid grid-cols-12 gap-4">
          <div className="flex flex-col col-span-3">
            <div className="flex flex-col gap-2 mt-4">
              <ShimmerButton width="100%" height={40} />
              <ShimmerButton width="100%" height={40} />
              <ShimmerButton width="100%" height={40} />
              <ShimmerButton width="100%" height={40} />
            </div>
          </div>
          <div className="flex flex-col col-span-3">
            <div className="flex flex-col gap-2 mt-4">
              <ShimmerButton width="100%" height={40} />
              <ShimmerButton width="100%" height={40} />
              <ShimmerButton width="100%" height={40} />
              <ShimmerButton width="100%" height={40} />
            </div>
          </div>
          <div className="flex flex-col col-span-6">
            <div className="flex flex-col gap-2 mt-4">
              <ShimmerThumbnail height={40} width="100%" />
              <ShimmerThumbnail height={40} width="100%" />
              <ShimmerThumbnail height={40} width="100%" />
              <ShimmerThumbnail height={40} width="100%" />
            </div>
          </div>
        </div>

        <div
          className="w-full flex flex-row gap-4 mt-4"
          style={{ height: "40px" }}
        >
          <div className="flex-grow" style={{ width: "90%" }}>
            <ShimmerThumbnail height={40} width="100%" rounded />
          </div>
          <div className="flex-grow" style={{ width: "10%" }}>
            <ShimmerThumbnail height={40} width="100%" rounded />
          </div>
        </div>
      </div>

      <div className="flex flex-col p-4">
        <div className="flex justify-between items-center w-full mb-4">
          <div className="flex gap-2">
            <ShimmerButton width={100} height={40} />
            <ShimmerButton width={100} height={40} />
          </div>
          <ShimmerButton width={100} height={40} />
        </div>
        <div
          className="flex justify-center items-center w-full"
          style={{ height: "50vh", border: "1px solid #555" }}
        >
          <p className="text-gray-500">Loading Preview...</p>
        </div>
      </div>
    </div>
  );
};

export default CustomiseNudgeLoading2;
